import { api } from 'common';

import { OutputBlockFormFields } from './FormFields';
import { OutputBlockOutputContent } from './OutputContent';
import { OutputBlockDocumentationMarkdown } from './documentation';
import { defaultOutputNodeLabelPrefix, getDefaultOutputNodeConfig } from './utils';
import { type BlockConfigProps } from '../../types';

export const outputConfig: BlockConfigProps<api.FlowDefinition.OutputBlock['config']> = {
  nodeHandles: [{ type: 'target' }],
  defaultLabelPrefix: defaultOutputNodeLabelPrefix,
  defaultConfig: getDefaultOutputNodeConfig(),
  configFields: {
    schema: api.FlowDefinition.OutputBlockConfigSchema,
    FormFields: OutputBlockFormFields,
  },
  documentationMarkdown: OutputBlockDocumentationMarkdown,
  OutputContentComponent: OutputBlockOutputContent,
};
